var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{staticClass:"isStyleBase",attrs:{"layout":"prev, pager, next","total":_vm.total,"page-size":_vm.pageSize,"pager-count":_vm.pagerCount,"current-page":+_vm.$route.query.page || 1},on:{"current-change":_vm.onCurrentChange}})}
var staticRenderFns = []

export { render, staticRenderFns }